import { render } from "./UserEdit.vue?vue&type=template&id=524df6eb&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=js"
export * from "./UserEdit.vue?vue&type=script&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=524df6eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-524df6eb"

export default script